import mutations from './appointmentModal.mutations'
import actions from './appointmentModal.actions'
import getters from './appointmentModal.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
